import React from 'react'

function CameraFilledIcon() {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle
        cx='16'
        cy='16'
        r='16'
        fill='#6267AC'
      />
      <path
        d='M9.33337 13.5855C9.33337 13.3519 9.33337 13.2351 9.34312 13.1368C9.43711 12.1882 10.1876 11.4377 11.1362 11.3437C11.2345 11.334 11.3576 11.334 11.6038 11.334C11.6986 11.334 11.746 11.334 11.7863 11.3315C12.3004 11.3004 12.7507 10.9759 12.9428 10.498C12.9579 10.4606 12.9719 10.4184 13 10.334C13.0282 10.2496 13.0422 10.2074 13.0573 10.17C13.2494 9.69207 13.6996 9.36756 14.2138 9.33642C14.254 9.33398 14.2985 9.33398 14.3875 9.33398H17.6126C17.7016 9.33398 17.746 9.33398 17.7863 9.33642C18.3004 9.36756 18.7507 9.69207 18.9428 10.17C18.9579 10.2074 18.9719 10.2496 19 10.334C19.0282 10.4184 19.0422 10.4606 19.0573 10.498C19.2494 10.9759 19.6996 11.3004 20.2138 11.3315C20.254 11.334 20.3015 11.334 20.3963 11.334C20.6425 11.334 20.7655 11.334 20.8639 11.3437C21.8125 11.4377 22.563 12.1882 22.657 13.1368C22.6667 13.2351 22.6667 13.3519 22.6667 13.5855V18.8007C22.6667 19.9208 22.6667 20.4808 22.4487 20.9086C22.257 21.285 21.951 21.5909 21.5747 21.7827C21.1469 22.0007 20.5868 22.0007 19.4667 22.0007H12.5334C11.4133 22.0007 10.8532 22.0007 10.4254 21.7827C10.0491 21.5909 9.74311 21.285 9.55136 20.9086C9.33337 20.4808 9.33337 19.9208 9.33337 18.8007V13.5855Z'
        stroke='white'
        strokeWidth='2'
        strokeLinejoin='round'
        strokeLinecap='round'
      />
      <path
        d='M16 19.0007C17.4728 19.0007 18.6667 17.8067 18.6667 16.334C18.6667 14.8612 17.4728 13.6673 16 13.6673C14.5273 13.6673 13.3334 14.8612 13.3334 16.334C13.3334 17.8067 14.5273 19.0007 16 19.0007Z'
        stroke='white'
        strokeWidth='2'
        strokeLinejoin='round'
        strokeLinecap='round'
      />
    </svg>
  )
}

export default CameraFilledIcon
